import L from 'leaflet';
import 'leaflet.markercluster';

window.L = L;
